import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import axios from '../../../../axios-order'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Box,
  Typography,
  Tab,
  Tabs,
  AppBar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button
} from '@material-ui/core'
import Modal from 'react-bootstrap/Modal'
import { ValidatorForm } from 'react-material-ui-form-validator'
import SelectField from '../../../../components/ui/basicSelectInput'
import BasicInputField from '../../../../components/ui/basicInput'
import GSTSummaryDashboard from './GSTSummary'
import B2CSummary from './B2CSummary'
import MatchedInvoice from './matchedInvoice'
import MismatchedInvoice from './mismatchedInvoice'
import MissingInAccount from './missingInAccount'
import MissingInGSTR from './missingInGSTR'
import CustomerInvoiceSummary from './CustomerInvoiceSummary'
import AllInvoiceRecon from './AllInvoiceRecon'
import IntelligentMatching from './intelligentMatching'
import CryptoJS from 'crypto-js'
import BoxWrapper from '../../../../components/ui/boxWrapper'
import { SSE_BASE_URL } from '../../../../axios-order';
import { generateUUID } from '../../../../utils/sseUtils';

const styles = function (theme) {
  return {
    root: {
      width: '400px'
    },
    tab: {
      [theme.breakpoints.up('md')]: {
        minWidth: 'auto'
      }
    }
  }
}
function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  }
}

class Showdetails extends Component {
  constructor(props) {
    super(props)

    let current_year = new Date().getFullYear()
    let yearArr = []
    for (let i = current_year - 7; i <= current_year + 5; i++) {
      let startYear = i
      let endYear = i + 1
      let endYearShort = endYear.toString().slice(-2)
      yearArr.push({
        id: `${startYear}-${endYearShort}`,
        value: `${startYear}-${endYearShort}`
      })
    }

    this.state = {
      allGSTReconData: [],
      GSTRecon_summary: [],
      customerInvoiceSummary: [],
      allInvoiceRecon: [],
      gstSummaryDashBoard: [],
      b2cs: [],
      threshold_value: 0,
      tabValue: 0,
      period: '',
      modalShow: false,
      customRoundOff: null,
      logsPage: 0,
      logsRowsPerPage: 5,
      yearArr: yearArr,
      errorMessage: false,
      fromMonthArr: [
        { id: 4, value: 'APR' },
        { id: 5, value: 'MAY' },
        { id: 6, value: 'JUN' },
        { id: 7, value: 'JUL' },
        { id: 8, value: 'AUG' },
        { id: 9, value: 'SEPT' },
        { id: 10, value: 'OCT' },
        { id: 11, value: 'NOV' },
        { id: 12, value: 'DEC' },
        { id: 1, value: 'JAN' },
        { id: 2, value: 'FEB' },
        { id: 3, value: 'MAR' }
      ],
      toMonthArr: [
        { id: 4, value: 'APR' },
        { id: 5, value: 'MAY' },
        { id: 6, value: 'JUN' },
        { id: 7, value: 'JUL' },
        { id: 8, value: 'AUG' },
        { id: 9, value: 'SEPT' },
        { id: 10, value: 'OCT' },
        { id: 11, value: 'NOV' },
        { id: 12, value: 'DEC' },
        { id: 1, value: 'JAN' },
        { id: 2, value: 'FEB' },
        { id: 3, value: 'MAR' }
      ],
      year: null,
      from_month: null,
      to_month: null,
      roundOffValue: 0,
      isProcessing: false,
      processingMessage: '',
      isExporting: false,
      showLogsModal: false,
      logsData: [],
      isLoadingLogs: false,
      isExportingLog: false,
      exportingLogId: null,
      businessEntityId: null
    }
    const decrypt = data => {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8)
    }
    let activeUrl = window.location.href
    let id = activeUrl.split('/')

    axios.get(`/arc/get_gst_json/${decrypt(id[4])}`).then(res => {
      if (typeof res.data == 'undefined') {
      } else {
        this.setState({
          allGSTReconData: res?.data?.record?.json_data?.jsonForExportExcel,
          GSTRecon_summary:
            res?.data?.record?.json_data?.jsonForExportExcel?.summary,
          customerInvoiceSummary:
            res?.data?.record?.json_data?.jsonForExportExcel
              ?.custInvoiceSummary,
          allInvoiceRecon:
            res?.data?.record?.json_data?.jsonForExportExcel?.allInvoiceRecon,
          b2cs: res?.data?.record?.json_data?.jsonForExportExcel?.b2cs,
          gstSummaryDashBoard:
            res?.data?.record?.json_data?.jsonForExportExcel
              ?.gstSummaryDashBoard,
          threshold_value:
            res?.data?.record?.json_data?.jsonForExportExcel?.threshold_value,
          fromDate: res?.data?.record?.json_data?.jsonForExportExcel?.fromDate,
          toDate: res?.data?.record?.json_data?.jsonForExportExcel?.toDate,
          reportDate:
            res?.data?.record?.json_data?.jsonForExportExcel?.reportDate,
          gstin: res?.data?.record?.json_data?.jsonForExportExcel?.gstin,
          financialYear:
            res?.data?.record?.json_data?.jsonForExportExcel?.financialYear,
          businessEntityId: res?.data?.record?.business_entity_id || null
        })
      }
    })
  }

  componentWillUnmount() {
    console.log("COMPONENT UNMOUNTING");
    if (this.eventSource) {
      console.log("CLOSING SSE FROM componentWillUnmount");
      this.eventSource.close();
      this.eventSource = null;
    }
  }

  handleSnackbarOpen = (message, severity = 'info') => {
    if (severity === 'error') {
      toast.error(message, { position: 'top-right', autoClose: 4000 });
    } else if (severity === 'success') {
      toast.success(message, { position: 'top-right', autoClose: 3000 });
    } else {
      toast.info(message, { position: 'top-right', autoClose: 4000 });
    }
  };

  initiateReconSSE = (sseToken) => {
    return new Promise((resolve, reject) => {

      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }

      console.log("SSE Starting point");

      const url = `${SSE_BASE_URL}/api/sse/${sseToken}`;

      this.eventSource = new EventSource(url);

      console.log(
        "SSE object created:",
        url,
        "readyState:",
        this.eventSource.readyState
      );

      this.eventSource.onopen = () => {
        this._sseOpened = true;
        console.log('SSE onopen fired, readyState:', this.eventSource.readyState);
        resolve();
      };

      this.eventSource.onmessage = (event) => {
        console.log("RAW SSE:", event.data);
        try {
          const data = JSON.parse(event.data);
          console.log("REAL SSE DATA:", data);
          if (data.status === "done" || data.status === "Pass") {
            console.log("Recon completed via SSE, recon_id:", data.recon_id);
            if (this.eventSource) {
              this.eventSource.close();
              this.eventSource = null;
            }
            this.fetchDetailedReport(data.recon_id);
          }
        } catch (err) {
          console.log("Ignoring non-json SSE message:", event.data);
        }
      };
      this.eventSource.onerror = (e) => {
        const rs = this.eventSource?.readyState;
        console.log(
          "SSE onerror fired, readyState:", rs,
          "timestamp:", new Date().toISOString()
        );
        if (rs === 2) {
          console.log("SSE permanently closed (readyState 2)");
          if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
          }
          if (!this._sseOpened) {
            reject(new Error("SSE connection failed permanently"));
          }
        }
      };
    });
  };


  handleViewLogs = () => {
    const businessEntityId =
      this.state.businessEntityId ||
      localStorage.getItem('business_entity_id') ||
      '2240'

    this.setState({
      isLoadingLogs: true,
      showLogsModal: true,
      logsData: []
    })

    axios
      .get(`/arc/get_gst_reconciliation/${businessEntityId}`)
      .then(res => {
        if (res.data && res.data.record) {
          const logsArray = Array.isArray(res.data.record)
            ? res.data.record
            : [res.data.record]
          this.setState({
            logsData: logsArray,
            isLoadingLogs: false
          })
        } else {
          this.setState({
            logsData: [],
            isLoadingLogs: false
          })
        }
      })
      .catch(error => {
        console.error('Error fetching logs:', error)
        alert('Failed to fetch logs. Please try again.')
        this.setState({
          isLoadingLogs: false,
          showLogsModal: false
        })
      })
  }

  handleCloseLogsModal = () => {
    this.setState({
      showLogsModal: false,
      logsData: []
    })
  }

  handleExportLog = reconId => {
    const contentType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const filename = `GSTR-1_Reconciliation_${reconId}.xlsx`

    this.setState({ isExportingLog: true, exportingLogId: reconId })

    axios
      .get(`/arc/get_gst_json/${reconId}`)
      .then(res => {
        if (res.data.status && res.data.record && res.data.record.json_data) {
          const exportData = res.data.record.json_data.jsonForExportExcel
          return axios.post(`/gst/download`, {
            data: { jsonForExportExcel: exportData }
          })
        } else {
          throw new Error('No data available for this reconciliation')
        }
      })
      .then(res => {
        this.downloadBase64File(contentType, res.data.file, filename)
      })
      .catch(error => {
        console.error('Error exporting log:', error)
        alert('Failed to export. Please try again.')
      })
      .finally(() => {
        this.setState({ isExportingLog: false, exportingLogId: null })
      })
  }

  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }

  downloadToExcel = () => {
    const contentType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const filename = `Gstr-1 Reconciliation Report.xlsx`

    this.setState({ isExporting: true })

    axios
      .post(`/gst/download`, {
        data: { jsonForExportExcel: this.state.allGSTReconData }
      })
      .then(res => {
        this.downloadBase64File(contentType, res.data.file, filename)
        this.setState({ isExporting: false })
      })
      .catch(error => {
        console.log(error)
        this.setState({ isExporting: false })
      })
  }

  handleTabChangeHandler = (event, newValue) => {
    this.setState({ tabValue: newValue })
  }

  handleBack = () => {
    this.props.history.push('/reconCards')
  }

  handlePeriodChange = event => {
    const selectedPeriod = event.target.value

    if (selectedPeriod === 'Custom') {
      this.setState({
        period: '',
        modalShow: true,
        year: null,
        from_month: null,
        to_month: null,
        roundOffValue: 0,
        customRoundOff: null,
        toMonthArr: [
          { id: 4, value: 'APR' },
          { id: 5, value: 'MAY' },
          { id: 6, value: 'JUN' },
          { id: 7, value: 'JUL' },
          { id: 8, value: 'AUG' },
          { id: 9, value: 'SEPT' },
          { id: 10, value: 'OCT' },
          { id: 11, value: 'NOV' },
          { id: 12, value: 'DEC' },
          { id: 1, value: 'JAN' },
          { id: 2, value: 'FEB' },
          { id: 3, value: 'MAR' }
        ]
      })
    } else {
      this.setState({ period: selectedPeriod })
    }
  }



  handleRunReport = async () => {
    try {
      this.setState({ isProcessing: true });

      this._sseOpened = false;
      const sseToken = generateUUID();

      const periodTypeMap = {
        'Current Month': 'current_month',
        'Previous Month': 'previous_month',
        'Current Quarter': 'current_quarter',
        'Previous Quarter': 'previous_quarter',
        'Current Financial Year': 'current_fy',
        'Previous Financial Year': 'previous_fy',
        Custom: 'custom'
      };

      const requestPayload = {
        report_type: 'gstr1',
        org_gstin: this.state.gstin || localStorage.getItem('gst'),
        business_entity_id:
          this.state.businessEntityId ||
          localStorage.getItem('business_entity_id'),
        period_type:
          periodTypeMap[this.state.period] || 'previous_month',
        sse_token: sseToken,
        functionality: 'GSTR1 RECON',
        threshold_value: this.state.threshold_value || 5,
      };
      await this.initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');

      this.setState({ processingMessage: 'Reconciliation is Running.' });

      const res = await axios.post(`/unified_auto_reconciliation`, requestPayload);
      console.log('Recon API response:', res.data);

      if (!res.data || res.data.status === false) {
        if (this.eventSource) {
          this.eventSource.close();
          this.eventSource = null;
        }
        this.setState({ isProcessing: false, processingMessage: '' });
        this.handleSnackbarOpen('Failed to initiate reconciliation', 'error');
        return;
      }

      this.handleSnackbarOpen('Reconciliation is Running', 'info');

    } catch (err) {
      console.error('handleRunReport error:', err);
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
      this.setState({ isProcessing: false, processingMessage: '' });
      this.handleSnackbarOpen('Error initiating reconciliation', 'error');
    }
  };

  fetchDetailedReport = (reconId) => {
    axios
      .get(`/arc/get_gst_json/${reconId}`)
      .then((res) => {
        if (res.data.status && res.data.record && !Array.isArray(res.data.record)) {
          if (res.data.record.status === 'Fail') {
            const errorMsg =
              res.data.record.json_data?.exception ||
              res.data.record.json_data?.message ||
              'Reconciliation failed. Please try again.';
            this.setState({ isProcessing: false, processingMessage: '' });
            this.handleSnackbarOpen(errorMsg, 'error');
            return;
          }
          const encrypt = (text) =>
            CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text.toString()));
          const newUrl = `/gstReconUpdatedTabDetails/${encrypt(reconId)}`;
          window.history.replaceState(null, "", newUrl);

          this.updateReportData(res.data);
        } else {
          this.setState({ isProcessing: false, processingMessage: '' });
          this.handleSnackbarOpen('Failed to fetch report. Please refresh.', 'error');
        }
      })
      .catch(() => {
        this.setState({ isProcessing: false, processingMessage: '' });
        this.handleSnackbarOpen('Error loading report data.', 'error');
      });
  };

  updateReportData = (responseData) => {
    const excel = responseData?.record?.json_data?.jsonForExportExcel;
    this.setState({
      allGSTReconData: excel,
      GSTRecon_summary: excel?.summary,
      customerInvoiceSummary: excel?.custInvoiceSummary,
      allInvoiceRecon: excel?.allInvoiceRecon,
      b2cs: excel?.b2cs,
      gstSummaryDashBoard: excel?.gstSummaryDashBoard,
      threshold_value: excel?.threshold_value,
      fromDate: excel?.fromDate,
      toDate: excel?.toDate,
      reportDate: excel?.reportDate,
      gstin: excel?.gstin,
      financialYear: excel?.financialYear,
      businessEntityId: responseData?.record?.business_entity_id || this.state.businessEntityId,
      loading: false,
      isProcessing: false,
      processingMessage: '',
    });

    toast.success('Reconciliation report loaded successfully!', {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  newReconModalClose = () => {
    this.setState({
      modalShow: false,
      threshold_value: this.state.threshold_value || 0,
      roundOffValue: 0,
      year: null,
      from_month: null,
      to_month: null,
      customRoundOff: null
    })
  }

  roundOffInputHandler = event => {
    const name = event.target.name
    const value = event.target.value

    if (value === 11 && name === 'threshold_value') {
      this.setState({
        customRoundOff: '',
        roundOffValue: value
      })
    } else if (name === 'customRoundOff') {
      if (
        String(value).split('.')[1] &&
        String(String(value).split('.')[1]).length > 2
      ) {
        return false
      }

      this.setState({ threshold_value: value, customRoundOff: value })
    } else {
      this.setState({
        threshold_value: value,
        roundOffValue: value,
        customRoundOff: null
      })
    }
  }

  inputHandler = event => {
    let name = event.target.name
    let value = event.target.value
    if (name === 'from_month') {
      let toMonthArr = this.state.fromMonthArr

      this.setState(prevState => ({
        ...prevState,
        toMonthArr: toMonthArr.filter(
          month_value =>
            (parseInt(value) < 4 &&
              parseInt(month_value.id) >= parseInt(value) &&
              parseInt(month_value.id) < 4) ||
            (parseInt(value) >= 4 &&
              parseInt(month_value.id) >= parseInt(value)) ||
            (parseInt(value) >= 4 && parseInt(month_value.id) < 4)
        )
      }))
    }
    this.setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  onSubmitHandler = async () => {
    this.setState({ modalShow: false, isProcessing: true});

    try {
      this._sseOpened = false;
      const sseToken = generateUUID();

      const requestPayload = {
        org_gstin: this.state.gstin || localStorage.getItem('gst'),
        threshold_value: this.state.threshold_value,
        from_month: this.state.from_month,
        to_month: this.state.to_month,
        financial_year: this.state.year,
        period_type: 'custom',
        report_type: 'gstr1',
        business_entity_id:
          this.state.businessEntityId ||
          localStorage.getItem('business_entity_id'),
        sse_token: sseToken,
        functionality: 'GSTR1 RECON',
      };

      await this.initiateReconSSE(sseToken);
      this.setState({ processingMessage: 'Custom Reconciliation is Running.' });

      const res = await axios.post(`/unified_auto_reconciliation`, requestPayload);

      if (!res.data || res.data.status === false) {
        if (this.eventSource) {
          this.eventSource.close();
          this.eventSource = null;
        }
        this.setState({ isProcessing: false, processingMessage: '' });
        this.handleSnackbarOpen('Failed to initiate custom reconciliation', 'error');
        return;
      }

      this.handleSnackbarOpen('Custom reconciliation is Running', 'info');

    } catch (err) {
      console.error('onSubmitHandler error:', err);
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
      this.setState({ isProcessing: false, processingMessage: '' });
      this.handleSnackbarOpen('Error initiating custom reconciliation', 'error');
    }
  }

  render() {
    const { classes } = this.props

    return (
      <React.Fragment>
        <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to   { transform: rotate(360deg); }
      }
    `}</style>
        {/* ---header--- */}
        <div
          style={{
            backgroundColor: '#f5f5f5',
            padding: '15px 20px',
            marginBottom: '0px'
          }}
        >
          <Grid container spacing={3} alignItems='center'>
            <Grid item xs={3}>
              <div
                style={{
                  fontSize: '12px',
                  lineHeight: '1.8',
                  marginBottom: '8px'
                }}
              >
                Report Dated : {this.state.reportDate}
                <br />
                Report Period : {this.state.fromDate} To {this.state.toDate}
              </div>
              <button
                className='button-outlined-primary'
                style={{ padding: '6px 20px', fontSize: '13px' }}
                onClick={this.handleBack}
              >
                BACK
              </button>
            </Grid>

            <Grid item xs={6}>
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    marginBottom: '12px',
                    color: '#333'
                  }}
                >
                  GSTR-1 Reconciliation Report
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    justifyContent: 'center'
                  }}
                >
                  <button
                    className='button-outlined-primary'
                    onClick={this.downloadToExcel}
                    disabled={this.state.isExporting}
                    style={{
                      padding: '6px 24px',
                      fontSize: '13px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      opacity: this.state.isExporting ? 0.85 : 1,
                      cursor: this.state.isExporting ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {this.state.isExporting ? (
                      <>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          style={{
                            animation: 'spin 0.9s linear infinite',
                            flexShrink: 0
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="8" cy="8" r="6"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeDasharray="28"
                            strokeDashoffset="10"
                            strokeLinecap="round"
                          />
                        </svg>
                        EXPORTING...
                      </>
                    ) : (
                      'EXPORT TO EXCEL'
                    )}
                  </button>
                  <button
                    className='button-outlined-secondary'
                    onClick={this.handleViewLogs}
                    style={{ padding: '6px 24px', fontSize: '13px' }}
                  >
                    LOGS
                  </button>
                </div>
              </div>
            </Grid>

            <Grid item xs={3}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  gap: '10px'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center'
                  }}
                >
                  <FormControl
                    variant='outlined'
                    size='small'
                    style={{
                      minWidth: '180px',
                      backgroundColor: '#fff'
                    }}
                  >
                    <InputLabel></InputLabel>
                    <Select
                      value={this.state.period}
                      onChange={this.handlePeriodChange}
                      label='Period'
                      disabled={this.state.isProcessing}
                      displayEmpty
                    >
                      <MenuItem value='' disabled>
                        Select Period
                      </MenuItem>
                      <MenuItem value='Current Month'>Current Month</MenuItem>
                      <MenuItem value='Previous Month'>Previous Month</MenuItem>
                      <MenuItem value='Current Quarter'>
                        Current Quarter
                      </MenuItem>
                      <MenuItem value='Previous Quarter'>
                        Previous Quarter
                      </MenuItem>
                      <MenuItem value='Current Financial Year'>
                        Current Financial Year
                      </MenuItem>
                      <MenuItem value='Previous Financial Year'>
                        Previous Financial Year
                      </MenuItem>
                      <MenuItem value='Custom'>Custom</MenuItem>
                    </Select>
                  </FormControl>

                  <Button
                    variant='contained'
                    color='primary'
                    onClick={this.handleRunReport}
                    disabled={this.state.isProcessing || !this.state.period}
                    style={{
                      padding: '8px 20px',
                      fontWeight: '600',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {this.state.isProcessing ? 'PROCESSING...' : 'RUN REPORT'}
                  </Button>
                </div>

                {this.state.isProcessing && (
                  <div
                    style={{
                      marginTop: '4px',
                      padding: '8px 12px',
                      backgroundColor: '#e3f2fd',
                      borderRadius: '4px',
                      fontSize: '11px',
                      color: '#1976d2',
                      textAlign: 'right',
                      border: '1px solid #90caf9'
                    }}
                  >
                    {this.state.processingMessage}
                  </div>
                )}

                <div
                  style={{
                    fontSize: '11px',
                    textAlign: 'right',
                    lineHeight: '1.6',
                    color: '#666'
                  }}
                >
                  Threshold Used: {this.state.threshold_value}
                  <br />
                  Financial Year:{' '}
                  {`${this.state.financialYear} - ${parseInt(this.state.financialYear) + 1
                    }`}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        {/* tab panel */}
        <div className={classes.TabPanelSection}>
          <AppBar position='static' color='default'>
            <Tabs
              value={this.state.tabValue}
              onChange={this.handleTabChangeHandler}
              indicatorColor='primary'
              textColor='primary'
              variant='scrollable'
              scrollButtons='auto'
              aria-label='scrollable auto tabs example'
            >
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: '#fff', color: '#000' }}
                label='GST Summary '
                {...a11yProps(0)}
              />
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: '#ddd', color: '#000' }}
                label='B2C Summary'
                {...a11yProps(1)}
              />
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: '#28a745', color: '#000' }}
                label='Matched Invoices'
                {...a11yProps(2)}
              />
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: 'red', color: '#fff' }}
                label='Mismatch Invoices'
                {...a11yProps(3)}
              />
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: '#1c50b1', color: '#fff' }}
                label='Intelligent Matching '
                {...a11yProps(4)}
              />
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: '#ffad33', color: '#000' }}
                label='Missing in Accounts'
                {...a11yProps(5)}
              />
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: '#ffbf80', color: '#000' }}
                label='Missing in GSTR1'
                {...a11yProps(6)}
              />
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: '#b3d9ff', color: '#000' }}
                label='Customerwise Summary'
                {...a11yProps(7)}
              />
              <Tab
                classes={{ root: classes.tab }}
                style={{ background: '#ffff4d', color: '#000' }}
                label='All Invoice(s)'
                {...a11yProps(8)}
              />
            </Tabs>
          </AppBar>

          <TabPanel value={this.state.tabValue} index={0}>
            <BoxWrapper boxTitle='GST Summary Dashboard'>
              <GSTSummaryDashboard
                b2bExportData={this.state.gstSummaryDashBoard['b2b+exp']}
                cdnr={this.state.gstSummaryDashBoard.cdnr}
                ddnr={this.state.gstSummaryDashBoard.ddnr}
                b2ba={this.state.gstSummaryDashBoard.b2ba}
              />
            </BoxWrapper>
          </TabPanel>

          <TabPanel value={this.state.tabValue} index={1}>
            <B2CSummary B2CSummaryData={this.state.b2cs} />
          </TabPanel>

          <TabPanel value={this.state.tabValue} index={2}>
            <MatchedInvoice
              matchedInvoiceData={this.state.GSTRecon_summary.matched}
            />
          </TabPanel>

          <TabPanel value={this.state.tabValue} index={3}>
            <MismatchedInvoice
              mismatchedInvoiceData={this.state.GSTRecon_summary.missMatched}
            />
          </TabPanel>

          <TabPanel value={this.state.tabValue} index={4}>
            <IntelligentMatching
              IntelligentMatchingData={
                this.state.GSTRecon_summary.intelligentMatched
              }
            />
          </TabPanel>

          <TabPanel value={this.state.tabValue} index={5}>
            <MissingInAccount
              missingInAccountData={
                this.state.GSTRecon_summary.missingInAccounts
              }
            />
          </TabPanel>

          <TabPanel value={this.state.tabValue} index={6}>
            <MissingInGSTR
              missingInGSTRData={this.state.GSTRecon_summary.missingInGstr}
            />
          </TabPanel>

          <TabPanel value={this.state.tabValue} index={7}>
            <CustomerInvoiceSummary
              CustomerInvoiceSummaryData={this.state.customerInvoiceSummary}
            />
          </TabPanel>

          <TabPanel value={this.state.tabValue} index={8}>
            <AllInvoiceRecon AllInvoiceReconData={this.state.allInvoiceRecon} />
          </TabPanel>
        </div>

        {/* Custom Period Modal */}
        <Modal
          size='lg'
          aria-labelledby='contained-modal-title-vcenter'
          centered
          show={this.state.modalShow}
          onHide={this.newReconModalClose}
          dialogClassName='modal-50w'
        >
          <Modal.Header closeButton className='modal-header'>
            <Modal.Title className='modal-title'>
              New GSTR-1 Reconciliation
            </Modal.Title>
          </Modal.Header>
          {this.state.errorMessage && (
            <div style={{ color: 'red', paddingLeft: '20px' }}>
              There is no data in GSTR1 Repository{' '}
            </div>
          )}
          <ValidatorForm
            ref='form'
            onSubmit={this.onSubmitHandler}
            onError={errors => console.log(errors)}
          >
            <Modal.Body>
              <div style={{ padding: '0px 20px 20px 20px' }}>
                <Grid container spacing={3}>
                  <Grid item sm={3}>
                    <p style={{ fontSize: '16px' }}>
                      Select Financial Year
                      <span style={{ color: 'red' }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={9}>
                    <SelectField
                      validator={['required']}
                      errorMsg={['This field is required']}
                      choice_id='id'
                      disabled={this.state.errorMessage}
                      choice_name='value'
                      name='year'
                      value={this.state.year ?? ''}
                      choices={this.state.yearArr}
                      textOnchangeFunction={this.inputHandler}
                    />
                  </Grid>
                </Grid>
              </div>

              <div style={{ padding: '0px 20px 20px 20px' }}>
                <Grid container spacing={3}>
                  <Grid item sm={3}>
                    <p style={{ fontSize: '16px' }}>
                      From Month<span style={{ color: 'red' }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={3}>
                    <SelectField
                      validator={['required']}
                      errorMsg={['This field is required']}
                      choice_id='id'
                      choice_name='value'
                      disabled={this.state.errorMessage}
                      name='from_month'
                      value={this.state.from_month ?? ''}
                      choices={this.state.fromMonthArr}
                      textOnchangeFunction={this.inputHandler}
                    />
                  </Grid>
                  <Grid item sm={3}>
                    <p style={{ fontSize: '16px' }}>
                      To Month<span style={{ color: 'red' }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={3}>
                    <SelectField
                      validator={['required']}
                      errorMsg={['This field is required']}
                      choice_id='id'
                      choice_name='value'
                      name='to_month'
                      disabled={this.state.errorMessage}
                      value={this.state.to_month ?? ''}
                      choices={this.state.toMonthArr}
                      textOnchangeFunction={this.inputHandler}
                    />
                  </Grid>
                </Grid>
              </div>

              <div style={{ padding: '0px 20px 20px 20px' }}>
                <Grid container spacing={3}>
                  <Grid item sm={3}>
                    <p style={{ fontSize: '16px' }}>Threshold value:</p>
                  </Grid>
                  <Grid item sm={9}>
                    <SelectField
                      choice_id='id'
                      choice_name='roundOff'
                      disabled={this.state.errorMessage}
                      name='threshold_value'
                      value={this.state.roundOffValue ?? 0}
                      choices={[
                        { id: 0, roundOff: 'No Threshold Value' },
                        { id: 1, roundOff: 'Upto 1' },
                        { id: 5, roundOff: 'Upto 5' },
                        { id: 10, roundOff: 'Upto 10' },
                        { id: 11, roundOff: 'Custom' }
                      ]}
                      textOnchangeFunction={this.roundOffInputHandler}
                    />
                  </Grid>
                </Grid>
              </div>

              {this.state.customRoundOff !== null && (
                <div
                  style={{
                    padding: '0px 20px 20px 20px',
                    marginTop: '30px',
                    marginBottom: '10px',
                    boxShadow: '0px 0px 3px 0px #fff , 0px 1px 1px 1px #ddd'
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item sm={3}>
                      <p style={{ marginTop: '30px', fontSize: '16px' }}>
                        Custom Round off
                        <span style={{ color: 'red' }}>*</span> :
                      </p>
                    </Grid>
                    <Grid item sm={9}>
                      <BasicInputField
                        inputType='number'
                        name='customRoundOff'
                        validator={['required']}
                        errorMsg={['This field is required']}
                        value={this.state.customRoundOff ?? ''}
                        textOnchangeFunction={this.roundOffInputHandler}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <button
                className='button-primary'
                type='submit'
                style={{ marginRight: '10px' }}
                disabled={this.state.isProcessing}
              >
                {this.state.isProcessing ? 'PROCESSING...' : 'Submit'}
              </button>
              <button
                className='button-outlined-secondary'
                type='button'
                onClick={this.newReconModalClose}
                disabled={this.state.isProcessing}
              >
                Close
              </button>
            </Modal.Footer>
          </ValidatorForm>
        </Modal>

        {/* LOGS MODAL - Matching Second Image UI */}
        <Modal
          size='xl'
          centered
          show={this.state.showLogsModal}
          onHide={this.handleCloseLogsModal}
          style={{ maxWidth: '90vw' }}
        >
          <Modal.Header
            closeButton
            style={{
              padding: '14px 20px',
              backgroundColor: '#03406d',
              borderBottom: 'none'
            }}
          >
            <Modal.Title
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '1rem',
                fontWeight: 600,
                color: '#fff'
              }}
            >
              <span style={{ marginRight: '8px' }}>⟲</span>
              GSTR-1 Reconciliation Logs
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: 0 }}>
            {this.state.isLoadingLogs ? (
              <div
                style={{
                  textAlign: 'center',
                  padding: '40px'
                }}
              >
                <div style={{ fontSize: '14px', color: '#666' }}>
                  Loading logs...
                </div>
              </div>
            ) : this.state.logsData.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <div style={{ fontSize: '14px', color: '#999' }}>
                  No logs available
                </div>
              </div>
            ) : (
              <div
                style={{
                  overflowX: 'auto',
                  maxHeight: '500px',
                  overflowY: 'auto'
                }}
              >
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: '13px'
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                      <th
                        style={{
                          padding: '12px 16px',
                          textAlign: 'left',
                          fontWeight: '600',
                          fontSize: '11px',
                          color: '#666',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid #ddd'
                        }}
                      >
                        ID
                      </th>
                      <th
                        style={{
                          padding: '12px 16px',
                          textAlign: 'center',
                          fontWeight: '600',
                          fontSize: '11px',
                          color: '#666',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid #ddd'
                        }}
                      >
                        Status
                      </th>
                      <th
                        style={{
                          padding: '12px 16px',
                          textAlign: 'left',
                          fontWeight: '600',
                          fontSize: '11px',
                          color: '#666',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid #ddd'
                        }}
                      >
                        Fiscal Year
                      </th>
                      <th
                        style={{
                          padding: '12px 16px',
                          textAlign: 'left',
                          fontWeight: '600',
                          fontSize: '11px',
                          color: '#666',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid #ddd'
                        }}
                      >
                        From Month
                      </th>
                      <th
                        style={{
                          padding: '12px 16px',
                          textAlign: 'left',
                          fontWeight: '600',
                          fontSize: '11px',
                          color: '#666',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid #ddd'
                        }}
                      >
                        To Month
                      </th>
                      <th
                        style={{
                          padding: '12px 16px',
                          textAlign: 'center',
                          fontWeight: '600',
                          fontSize: '11px',
                          color: '#666',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid #ddd'
                        }}
                      >
                        Threshold
                      </th>
                      <th
                        style={{
                          padding: '12px 16px',
                          textAlign: 'left',
                          fontWeight: '600',
                          fontSize: '11px',
                          color: '#666',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid #ddd'
                        }}
                      >
                        Date & Time
                      </th>
                      <th
                        style={{
                          padding: '12px 16px',
                          textAlign: 'center',
                          fontWeight: '600',
                          fontSize: '11px',
                          color: '#666',
                          textTransform: 'uppercase',
                          borderBottom: '1px solid #ddd'
                        }}
                      >
                        Export
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.logsData
                      .slice(
                        this.state.logsPage * this.state.logsRowsPerPage,
                        this.state.logsPage * this.state.logsRowsPerPage +
                        this.state.logsRowsPerPage
                      )
                      .map((log, index) => {
                        const getMonthName = monthNum => {
                          const months = {
                            1: 'Jan',
                            2: 'Feb',
                            3: 'Mar',
                            4: 'Apr',
                            5: 'May',
                            6: 'Jun',
                            7: 'Jul',
                            8: 'Aug',
                            9: 'Sept',
                            10: 'Oct',
                            11: 'Nov',
                            12: 'Dec'
                          }
                          return months[monthNum] || monthNum
                        }

                        return (
                          <tr
                            key={log.id || index}
                            style={{
                              borderBottom: '1px solid #f0f0f0',
                              backgroundColor:
                                index % 2 === 0 ? '#fff' : '#fafafa'
                            }}
                          >
                            <td
                              style={{
                                padding: '12px 16px',
                                color: '#333'
                              }}
                            >
                              {log.id}
                            </td>
                            <td
                              style={{
                                padding: '12px 16px',
                                textAlign: 'center'
                              }}
                            >
                              <span
                                style={{
                                  padding: '4px 12px',
                                  borderRadius: '12px',
                                  fontSize: '11px',
                                  fontWeight: '600',
                                  display: 'inline-block',
                                  textTransform: 'uppercase',
                                  backgroundColor:
                                    log.status === 'Pass'
                                      ? '#d4edda'
                                      : '#f8d7da',
                                  color:
                                    log.status === 'Pass'
                                      ? '#155724'
                                      : '#721c24'
                                }}
                              >
                                {log.status || 'Pass'}
                              </span>
                            </td>
                            <td
                              style={{
                                padding: '12px 16px',
                                color: '#555'
                              }}
                            >
                              {log.fiscal_year
                                ? `${log.fiscal_year}-${parseInt(log.fiscal_year) + 1
                                }`
                                : '-'}
                            </td>
                            <td
                              style={{
                                padding: '12px 16px',
                                color: '#555'
                              }}
                            >
                              {log.from_month
                                ? getMonthName(log.from_month)
                                : '-'}
                            </td>
                            <td
                              style={{
                                padding: '12px 16px',
                                color: '#555'
                              }}
                            >
                              {log.to_month ? getMonthName(log.to_month) : '-'}
                            </td>
                            <td
                              style={{
                                padding: '12px 16px',
                                textAlign: 'center',
                                color: '#555'
                              }}
                            >
                              {log.threshold_value !== undefined &&
                                log.threshold_value !== null
                                ? log.threshold_value
                                : '-'}
                            </td>
                            <td
                              style={{
                                padding: '12px 16px',
                                color: '#555'
                              }}
                            >
                              {log.upload_date || '-'}
                            </td>
                            <td
                              style={{
                                padding: '12px 16px',
                                textAlign: 'center'
                              }}
                            >
                              {log.status === 'Pass' ? (
                                <button
                                  onClick={() => this.handleExportLog(log.id)}
                                  disabled={this.state.isExportingLog && this.state.exportingLogId === log.id}
                                  style={{
                                    padding: '6px 10px',
                                    backgroundColor: '#28a745',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: (this.state.isExportingLog && this.state.exportingLogId === log.id)
                                      ? 'not-allowed' : 'pointer',
                                    fontSize: '11px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '34px',
                                    minHeight: '28px',
                                  }}
                                >
                                  {this.state.isExportingLog && this.state.exportingLogId === log.id ? (
                                    <span
                                      style={{
                                        width: '12px',
                                        height: '12px',
                                        border: '2px solid currentColor',
                                        borderTopColor: 'transparent',
                                        borderRadius: '50%',
                                        display: 'inline-block',
                                        animation: 'spin 0.7s linear infinite',
                                        flexShrink: 0,
                                      }}
                                    />
                                  ) : (
                                    <svg
                                      width='14'
                                      height='14'
                                      viewBox='0 0 24 24'
                                      fill='none'
                                      stroke='currentColor'
                                      strokeWidth='2'
                                      style={{ verticalAlign: 'middle' }}
                                    >
                                      <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'></path>
                                      <polyline points='7 10 12 15 17 10'></polyline>
                                      <line x1='12' y1='15' x2='12' y2='3'></line>
                                    </svg>
                                  )}
                                </button>
                              ) : (
                                <span style={{ color: '#999' }}>-</span>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer
            style={{
              padding: '12px 20px',
              borderTop: '1px solid #ddd',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <div style={{ fontSize: '12px', color: '#666' }}>
              Rows per page:
              <select
                value={this.state.logsRowsPerPage}
                onChange={e => {
                  this.setState({
                    logsRowsPerPage: parseInt(e.target.value, 10),
                    logsPage: 0
                  })
                }}
                style={{
                  marginLeft: '8px',
                  padding: '4px 8px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  fontSize: '12px'
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </select>
              <span style={{ marginLeft: '16px' }}>
                {this.state.logsPage * this.state.logsRowsPerPage + 1}–
                {Math.min(
                  (this.state.logsPage + 1) * this.state.logsRowsPerPage,
                  this.state.logsData.length
                )}{' '}
                of {this.state.logsData.length}
              </span>
            </div>

            <div style={{ display: 'flex', gap: '6px' }}>
              <button
                onClick={() =>
                  this.setState({ logsPage: this.state.logsPage - 1 })
                }
                disabled={this.state.logsPage === 0}
                style={{
                  padding: '4px 10px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  backgroundColor: '#fff',
                  cursor: this.state.logsPage === 0 ? 'not-allowed' : 'pointer',
                  opacity: this.state.logsPage === 0 ? 0.5 : 1
                }}
              >
                ‹
              </button>
              <button
                onClick={() =>
                  this.setState({ logsPage: this.state.logsPage + 1 })
                }
                disabled={
                  (this.state.logsPage + 1) * this.state.logsRowsPerPage >=
                  this.state.logsData.length
                }
                style={{
                  padding: '4px 10px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  backgroundColor: '#fff',
                  cursor:
                    (this.state.logsPage + 1) * this.state.logsRowsPerPage >=
                      this.state.logsData.length
                      ? 'not-allowed'
                      : 'pointer',
                  opacity:
                    (this.state.logsPage + 1) * this.state.logsRowsPerPage >=
                      this.state.logsData.length
                      ? 0.5
                      : 1
                }}
              >
                ›
              </button>
            </div>

            <button
              onClick={this.handleCloseLogsModal}
              style={{
                padding: '6px 20px',
                border: '1px solid #ccc',
                borderRadius: '3px',
                backgroundColor: '#fff',
                cursor: 'pointer',
                fontSize: '12px',
                textTransform: 'uppercase',
                fontWeight: '500'
              }}
            >
              CLOSE
            </button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}

Showdetails.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Showdetails)
